var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwtnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4c9cd6;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22,
    cy: 22,
    r: 22
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.48,29.7A11,11,0,0,0,29.55,18.64c0-.17,0-.34,0-.51a7.73,7.73,0,0,0,1.94-2,7.66,7.66,0,0,1-2.24.61A3.86,3.86,0,0,0,31,14.58a7.78,7.78,0,0,1-2.47.95,3.85,3.85,0,0,0-2.83-1.23,3.89,3.89,0,0,0-3.89,3.89,3.65,3.65,0,0,0,.1.88,11.06,11.06,0,0,1-8-4.06,3.9,3.9,0,0,0,1.21,5.19,3.81,3.81,0,0,1-1.77-.49v.05a3.9,3.9,0,0,0,3.12,3.82,3.8,3.8,0,0,1-1,.13,3.48,3.48,0,0,1-.73-.07,3.88,3.88,0,0,0,3.63,2.7A7.77,7.77,0,0,1,13.45,28c-.31,0-.62,0-.93-.05a11,11,0,0,0,6,1.74"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwtnew);
export default __webpack_public_path__ + "static/media/twtnew.b3a2c5a264a8c1f2fa92e50898e27318.svg";
export { ForwardRef as ReactComponent };